import React, { useEffect, useState } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import Chart from '../../../components/chart/Chart'
import { doc, getDoc, onSnapshot, updateDoc } from "firebase/firestore"
import {  Link, useParams } from "react-router-dom"
import { db } from '../../../firebase'
import ConfirmStatusBox from '../../../components/ConfirmStatusBox'
import { getFunctions, httpsCallable } from "firebase/functions";

const Single = ({user}) => {

  const {luxurymessageId} = useParams()


  const [ luxurymessageData, setLuxurymessageData ] = useState("")

  const [openStatus, setOpenStatus] = useState(false)


  const getLuxurymessageInfo = () => {

    onSnapshot(doc(db, "luxuryWhatsappMessages", luxurymessageId), (doc) => {
  
     console.log("Current data: ", doc.data());
  
  
    setLuxurymessageData({id: doc.id, ...doc.data()})
  
    
   });
  
  
  }

  useEffect(()=>{

    getLuxurymessageInfo()
    

  }, [])



return (
  <>

<div className='single'>
      <Sidebar/>
      <div className='singleContainer'>
        
        <Navbar/>
      
        <div className="top">
            
          <div className="left">

           <div style = {{display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'center', paddingLeft:20, paddingRight:20, }}>

            <h2 className='title'>Luxury Message Information</h2>
             <Link to={`/premiummessages/edit/${luxurymessageId}`} 
                style={{ border: '1px solid gray', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:"", cursor:'pointer'}}>
                <span style={{color:'black', fontWeight:'bold'}}>Edit Details</span>
            </Link>

           </div>

            <div className='item'>

                <div className="details">
               
                  <div className='detailItem'>
                    <span className='itemKey'>Service Quality:</span>
                    <span className='itemValue'>{luxurymessageData.servicequalitystatus}</span>
                  </div>

                  <div className='detailItem'>
                    <span className='itemKey'>Service Speed:</span>
                    <span className='itemValue'>{luxurymessageData.servicespeedstatus}</span>
                  </div>

                  <div className='detailItem'>
                    <span className='itemKey'>Staff Behavioural:</span>
                    <span className='itemValue'>{luxurymessageData.staffbehaviouralstatus}</span>
                  </div>

                   <div className='detailItem'>
                    <span className='itemKey'>Outlet Ambience:</span>
                    <span className='itemValue'>{luxurymessageData.outletambiencestatus}</span>
                  </div>

                   <div className='detailItem'>
                    <span className='itemKey'>Value For Money:</span>
                    <span className='itemValue'>{luxurymessageData.valueaverageformoneystatus}</span>
                  </div>

                   <div className='detailItem'>
                    <span className='itemKey'>Outlet Ambience:</span>
                    <span className='itemValue'>{luxurymessageData.outletambiencestatus}</span>
                  </div>

                   <div className='detailItem'>
                    <span className='itemKey'>Customer Return Status:</span>
                    <span className='itemValue'>{luxurymessageData.customeraveragereturnratestatus}</span>
                  </div>

                    <div className='detailItem'>
                    <span className='itemKey'>Whatsapp Message:</span>
                    <span className='itemValue'>{luxurymessageData.whatsappmessage}</span>
                  </div>
              
                </div>

              

            </div>
          </div>
      
        </div>
      
      </div>
     
    </div>
      {/* <ConfirmStatusBox
        openStatus={openStatus}
        closeDialog={() => setOpenStatus(false)}
        statusFunction={handleStatus }
      /> */}
    </>
 
  )
}

export default Single

